import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '漫画分类',
    links: [
      { name: '热血', path: '/category/rexue' },
      { name: '恋爱', path: '/category/lianai' },
      { name: '奇幻', path: '/category/qihuan' },
      { name: '悬疑', path: '/category/xuanyi' }
    ]
  },
  {
    title: '更多分类',
    links: [
      { name: '搞笑', path: '/category/gaoxiao' },
      { name: '动作', path: '/category/dongzuo' },
      { name: '校园', path: '/category/xiaoyuan' },
      { name: '都市', path: '/category/dushi' }
    ]
  },
  {
    title: '关于本站',
    links: [
      { name: '关于我们', path: '/about' },
      { name: '热门推荐', path: '/' },
      { name: '最新更新', path: '/' },
      { name: '完结作品', path: '/' }
    ]
  }
];

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="col-span-2 md:col-span-1">
              <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap cursor-pointer">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                  <i className="ri-book-open-line text-background-50 text-lg"></i>
                </div>
                <span className="text-lg font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
                  韩漫大全
                </span>
              </Link>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                韩国漫画大全网收录超万部韩漫作品，全部免费在线阅读，涵盖连载与完结经典之作，每日更新热门韩漫，是韩漫爱好者的一站式阅读平台。
              </p>
              <div className="flex items-center gap-3">
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer" aria-label="QQ">
                  <i className="ri-qq-line"></i>
                </a>
              </div>
            </div>

            {footerLinks.map((group) => (
              <div key={group.title}>
                <h4 className="text-sm font-semibold text-foreground-950 mb-4">{group.title}</h4>
                <ul className="flex flex-col gap-3">
                  {group.links.map((link) => (
                    <li key={link.name}>
                      <Link
                        to={link.path}
                        className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
                      >
                        {link.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-500">
              &copy; 2026 韩漫大全 - 免费在线韩漫阅读网. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">隐私政策</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">使用条款</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}